<template>
  <section class="container">
    <div class="row">
      <div class="col text-center">
        <img src="/assets/images/404.png" alt="404" />
        <p>Ops...</p>
      </div>
    </div>
  </section>
</template>

<script setup></script>

<style scoped></style>